import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsZoom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsZoom"><Path d="M10.707 14.707L7.41406 18H10V20H4V14H6V16.5859L9.29297 13.293L10.707 14.707Z" fill="currentColor"/><Path d="M18 16.5859V14H20V20H14V18H16.5859L13.293 14.707L14.707 13.293L18 16.5859Z" fill="currentColor"/><Path d="M10 6H7.41406L10.707 9.29297L9.29297 10.707L6 7.41406V10H4V4H10V6Z" fill="currentColor"/><Path d="M20 10H18V7.41406L14.707 10.707L13.293 9.29297L16.5859 6H14V4H20V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsZoom;
